import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

/* js imports */
import useCheckPathName from "../utils/useCheckPathname";
import { chefBioData } from "../data/chefBioData";

/* comp imports */
import BackArrow from "../components/BackArrow";
import PageTransition from "../components/PageTransition";
import ChefBioContentWrapper from "../components/ChefBioContentWrapper";
import MainDisclaimerModal from "../components/modals/MainDisclaimerModal";

const ChefsBio = () => {
  useCheckPathName();
  const navigate = useNavigate();
  const { chefSlug } = useParams();
  const chefNames = ["ajay-chopra"];
  const [selectedChefBioData, setSelectedChefBioData] = useState({});

  useEffect(() => {
    if (chefSlug) {
      if (chefNames.includes(chefSlug)) {
        if (chefBioData.length) {
          const tempChefData = chefBioData.find(
            (chef) => chef.chefBioSlug === chefSlug
          );
          if (Object.keys(tempChefData).length > 0) {
            setSelectedChefBioData(tempChefData);
          }
        }
      } else {
        navigate("/chefs");
      }
    }
  }, []);

  const handleRedirect = (pageName) => {
    navigate(pageName);
  };

  return (
    <>
      <PageTransition />
      <div
        className={`page-main-wrapper ${
          Object.keys(selectedChefBioData).length > 0 &&
          selectedChefBioData.imageBgClass
        }`}
      >
        <BackArrow handleRedirect={handleRedirect} linkName="/chefs" />
        <ChefBioContentWrapper
          selectedChefBioData={selectedChefBioData && selectedChefBioData}
        />
        <MainDisclaimerModal />
      </div>
    </>
  );
};

export default ChefsBio;
